export default __webpack_public_path__ + "static/1010-4da04f929dddac34bf43fce71746848b.gif";